import { useEffect, useState } from "react";
import { AiOutlineCalendar } from "react-icons/ai";
import PopupWrapper from "../../Components/PopUp/PopupWrapper";
import { FaRegEdit } from "react-icons/fa";
import { _24To12, decryptor, getPayloadHash } from "../../services/helper";
import { getLocalToken } from "../../services/token";
import { postFormDataCall } from "../../services/apiCall";
import SkeletonSlot from "../../Components/Loader/Skeleton/SlotSkeleton";
import Calendar from "../../Components/Calender";

const CompanySlot = () => {
  const weekDayArray = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  const [isLoading, setIsLoading] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [mode, setMode] = useState("weekday");
  const [selectedDate, setSelectedDate] = useState("");

  const [slots, setSlots] = useState(
    weekDayArray.map((day) => ({
      slotId: null,
      day,
      startTime: "",
      endTime: "",
    }))
  );

  const [slotsForDate, setSlotsForDate] = useState(
    weekDayArray.map((day) => ({
      slotId: null,
      day,
      startTime: "",
      endTime: "",
    }))
  );
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [error, setError] = useState({ startTime: "", endTime: "" });

  const getWeekSlot = async () => {
    setIsLoading(true);
    try {
      const token = getLocalToken();
      let userInfo = decryptor({ encryptedData: token });
      if (!userInfo) return null;

      userInfo = JSON.parse(userInfo);

      let payload = {
        user_id: userInfo?.user_id,
      };

      const dataToSend = getPayloadHash({ data: payload });
      let response = await postFormDataCall(
        "/get-slots",
        {},
        { data: dataToSend }
      );

      if (response?.success && response?.data) {
        setSlots((prev) =>
          prev.map((item) => {
            for (let resSlot of response.data) {
              if (
                resSlot.slot_type === "weekday" &&
                resSlot.weekday.toLowerCase() === item.day?.toLowerCase()
              ) {
                item.slotId = resSlot?.id;
                item.startTime = resSlot?.start_time;
                item.endTime = resSlot?.end_time;
                return item;
              }
            }
            return item;
          })
        );

        setSlotsForDate(response.data.filter((e) => e.slot_type === "date"));
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const checkValidation = () => {
    let isValid = true;

    if (!selectedSlot?.startTime) {
      isValid = false;
      setError((prev) => ({ ...prev, startTime: "Start time is required" }));
    }

    if (!selectedSlot?.endTime) {
      isValid = false;
      setError((prev) => ({ ...prev, endTime: "End time is required" }));
    }

    if (selectedSlot?.startTime && selectedSlot?.endTime) {
      let startTimeHour = Number(selectedSlot?.startTime?.split(":")[0]);
      let endTimeHour = Number(selectedSlot?.endTime?.split(":")[0]);

      let startTimeMin = Number(selectedSlot?.startTime?.split(":")[1]);
      let endTimeMin = Number(selectedSlot?.endTime?.split(":")[1]);

      if (startTimeHour > endTimeHour) {
        isValid = false;
        setError((prev) => ({
          ...prev,
          endTime: "End time should be more than Start time",
        }));
      }

      if (startTimeHour === endTimeHour && startTimeMin >= endTimeMin) {
        isValid = false;
        setError((prev) => ({
          ...prev,
          endTime: "End time should be more than Start time",
        }));
      }
    }

    return isValid;
  };

  const weekSlotConfirmHandler = async () => {
    try {
      if (!checkValidation()) {
        return null;
      }

      const token = getLocalToken();
      let userInfo = decryptor({ encryptedData: token });
      if (!userInfo) return null;

      userInfo = JSON.parse(userInfo);

      if (mode === "weekday") {
        let payload = {
          user_id: userInfo?.user_id,
          slot_type: "weekday",
          weekday: selectedSlot?.day?.toLowerCase(),
          start_time: selectedSlot?.startTime,
          end_time: selectedSlot?.endTime,
        };

        const dataToSend = getPayloadHash({ data: payload });
        let response = await postFormDataCall(
          "/create-slot",
          {},
          { data: dataToSend }
        );
      } else if (mode === "date") {
        let payload = {
          user_id: userInfo?.user_id,
          slot_type: "date",
          slot_date: selectedSlot?.day,
          start_time: selectedSlot?.startTime,
          end_time: selectedSlot?.endTime,
        };

        const dataToSend = getPayloadHash({ data: payload });
        let response = await postFormDataCall(
          "/create-slot",
          {},
          { data: dataToSend }
        );
      }

      setSelectedSlot(null);
      return true;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const deleteWeekSlot = async () => {
    try {
      const token = getLocalToken();
      let userInfo = decryptor({ encryptedData: token });
      if (!userInfo) return null;

      userInfo = JSON.parse(userInfo);

      let payload = {
        slot_id: selectedSlot?.slotId,
        user_id: userInfo?.user_id,
      };

      const dataToSend = getPayloadHash({ data: payload });
      let response = await postFormDataCall(
        "/delete-slot",
        {},
        { data: dataToSend }
      );

      if (response?.success) {
        setSlots(
          weekDayArray.map((day) => ({
            slotId: null,
            day,
            startTime: "",
            endTime: "",
          }))
        );
        getWeekSlot();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const dateSelectHandler = (dateValue) => {
    setSelectedDate(dateValue);
    const availableSlot = slotsForDate.filter(
      (e) => e.slot_date?.split("T")[0] === dateValue
    );
    setSelectedSlot({
      id: availableSlot.length > 0 ? availableSlot[0]?.id : null,
      day: dateValue,
      startTime: availableSlot.length > 0 ? availableSlot[0]?.start_time : "",
      endTime: availableSlot.length > 0 ? availableSlot[0]?.end_time : "",
    });
  };

  useEffect(() => {
    getWeekSlot();
  }, []);

  return (
    <>
      <h1 className="text-3xl font-semibold sticky top-0 bg-white z-40 py-3 border-b border-gray-300">
        Slots
      </h1>
      {isLoading ? (
        <SkeletonSlot />
      ) : (
        <>
          <div className="w-full mx-auto p-4">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Slot Management
            </h2>

            <div className="flex gap-4 mb-4">
              <button
                className={`px-4 py-2 rounded-lg ${
                  mode === "weekday" ? "bg-blue-600 text-white" : "bg-gray-200"
                }`}
                onClick={() => setMode("weekday")}
              >
                Weekday
              </button>
              <button
                className={`px-4 py-2 rounded-lg ${
                  mode === "date" ? "bg-blue-600 text-white" : "bg-gray-200"
                }`}
                onClick={() => setMode("date")}
              >
                Date
              </button>
            </div>

            {mode === "weekday" && (
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-blue-600 text-white">
                    <th className="font-medium border p-2 w-20 rounded-tl-md">
                      Sl. No.
                    </th>
                    <th className="font-medium border p-2">Weekday</th>
                    <th className="font-medium border p-2">Start Time</th>
                    <th className="font-medium border p-2">End Time</th>
                    <th className="font-medium border p-2 w-40 rounded-tr-md">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {slots.map((slot, index) => (
                    <tr key={slot.day} className="border">
                      <td className="border p-2">
                        <div className="flex justify-center">{index + 1}</div>
                      </td>
                      <td className="border p-2">
                        <div className="flex justify-center capitalize">
                          {slot.day}
                        </div>
                      </td>
                      <td className="border p-2">
                        <div className="flex justify-center">
                          {slot.startTime ? _24To12(slot.startTime) : "-"}
                        </div>
                      </td>
                      <td className="border p-2">
                        <div className="flex justify-center">
                          {slot.endTime ? _24To12(slot.endTime) : "-"}
                        </div>
                      </td>
                      <td className="border px-2">
                        <div className="flex justify-center">
                          <button
                            type="button"
                            className="text-sm px-2 py-1 rounded-md border border-blue-600 bg-blue-50 text-blue-600 hover:scale-105 transition-all duration-75 flex items-center gap-2"
                            onClick={() => {
                              setConfirmOpen(true);
                              setSelectedSlot(slot);
                            }}
                          >
                            Schedule
                            <FaRegEdit className="text-xl" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {mode === "date" && (
              <div className="flex flex-col lg:flex-row gap-10 lg:gap-0 w-full">
                <div className="w-full lg:w-1/2">
                  <Calendar
                    setSelectedDateUsable={dateSelectHandler}
                    slots={slotsForDate}
                  />
                </div>
                <div className="w-full lg:w-1/2 flex flex-col gap-2">
                  <div className="flex gap-2 text-lg">
                    <span className="font-semibold">Selected Date :</span>
                    <span className="text-gray-700">{selectedDate}</span>
                  </div>
                  <div className="flex gap-2 text-lg">
                    <button
                      type="button"
                      className="text-lg px-3 py-1.5 rounded-md border border-blue-600 bg-blue-50 text-blue-600 hover:scale-105 transition-all duration-75 flex items-center gap-2"
                      onClick={() => {
                        setConfirmOpen(true);
                        setSelectedSlot({
                          id: selectedSlot?.id,
                          day: selectedSlot?.day,
                          startTime: selectedSlot?.startTime,
                          endTime: selectedSlot?.endTime,
                        });
                      }}
                    >
                      Schedule
                      <FaRegEdit className="text-xl" />
                    </button>
                  </div>

                  {selectedSlot?.id ? (
                    <>
                      <div className="flex gap-2 text-lg mt-4">
                        <span className="font-semibold">Start Time :</span>
                        <span className="text-gray-700">
                          {_24To12(selectedSlot?.startTime)}
                        </span>
                      </div>
                      <div className="flex gap-2 text-lg">
                        <span className="font-semibold">End Time :</span>
                        <span className="text-gray-700">
                          {_24To12(selectedSlot?.endTime)}
                        </span>
                      </div>
                    </>
                  ) : (
                    <div className="text-gray-700 mt-4">No Slots Scheduled</div>
                  )}
                </div>
              </div>
            )}
          </div>
        </>
      )}

      <PopupWrapper open={confirmOpen}>
        <div className="w-full sm:w-1/2 lg:w-1/3 min-h-1/4 rounded-lg bg-white flex flex-col justify-between p-5 shadow-2xl shadow-gray-800">
          <div className="flex">
            <h6 className="text-xl font-bold text-gray-900">
              Set Slot for {selectedSlot?.day || "-"}
            </h6>
          </div>

          <div className="flex flex-col gap-4 mt-4">
            {/* <h3 className="text-lg font-semibold text-gray-900">{selectedSlot?.day || "-"}</h3> */}

            <div className="flex flex-col gap-1 relative">
              <label className="font-semibold text-gray-700">Start Time</label>
              <input
                type="time"
                className="p-2 border rounded-lg w-full"
                value={selectedSlot?.startTime}
                onChange={(e) => {
                  setSelectedSlot({
                    ...selectedSlot,
                    startTime: e.target.value,
                  });
                  setError((prev) => ({ ...prev, startTime: "" }));
                }}
              />
              <span className="text-xs font-bold absolute top-full left-0 text-red-500">
                {error.startTime}
              </span>
            </div>

            <div className="flex flex-col gap-1 relative">
              <label className="font-semibold text-gray-700">End Time</label>
              <input
                type="time"
                className="p-2 border rounded-lg w-full"
                value={selectedSlot?.endTime}
                onChange={(e) => {
                  setSelectedSlot({ ...selectedSlot, endTime: e.target.value });
                  setError((prev) => ({ ...prev, endTime: "" }));
                }}
              />
              <span className="text-xs font-bold absolute top-full left-0 text-red-500">
                {error.endTime}
              </span>
            </div>
          </div>

          <div className="w-full flex items-center justify-between mt-6">
            <button
              type="button"
              className="px-3 py-1.5 rounded-lg bg-gray-200 text-gray-600 border border-gray-600 hover:scale-105 transition-all duration-150 whitespace-nowrap"
              onClick={() => {
                setConfirmOpen(false);
                setError((prev) => ({
                  ...prev,
                  startTime: "",
                  endTime: "",
                }));
              }}
            >
              Close
            </button>

            <div className="flex items-center gap-2">
              {selectedSlot?.slotId && (
                <button
                  type="button"
                  className="px-3 py-1.5 rounded-lg bg-red-50 text-red-500 border border-red-500 hover:scale-105 transition-all duration-150 whitespace-nowrap"
                  onClick={() => {
                    setConfirmOpen(false);
                    deleteWeekSlot();
                  }}
                >
                  Delete Slot
                </button>
              )}
              <button
                type="button"
                className="w-24 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-500 hover:scale-105 transition-all duration-150"
                onClick={async () => {
                  if (await weekSlotConfirmHandler()) {
                    setConfirmOpen(false);
                    getWeekSlot();
                  }
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </PopupWrapper>
    </>
  );
};

export default CompanySlot;
